module.exports = __webpack_public_path__ + "img/Openanaccount1.ebcf216a.png";